import React, { useState,useEffect } from 'react';
import { Container,ListGroup } from 'react-bootstrap';
import PageStaticData from './PageStaticData';
import SidebarMenu from './SidebarMenu';
import Section from './Section';
const PageBody = ({ pageData }) => 
{
    //console.info('PageData',pageData);
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[sp,setPageData]=useState([]);
    useEffect(()=>
    {
        if(pageData)
        {
            setPageData(pageData);
        }
        // eslint-disable-next-line
    },[pageData])
    return (
        <React.Fragment>
        {sp &&  
            <React.Fragment>
            { sp.sp_sidebar === 1 && sp.sidebarData.length > 0 ? (                
                <Container>
                    <ListGroup horizontal className='sidebar-menu'>
                        {sp.sidebarData.map((menu, index)=>( 
                            <SidebarMenu menuData={menu} key={index} />                               
                        ))}
                    </ListGroup>
                </Container>
            ) : null }
            {sp.sp_dynamic === 1 ? (
                <React.Fragment>
                {sp.sp_section_position === 2 ? (
                    <React.Fragment>
                    {sp.pageSection ? sp.pageSection.map((sps, index)=>(
                        <Section key={index} sp={sp} ssId={sps.sps_ss_id} sdId={sp.sp_sd_id} />
                    )) : null}
                    <Container className='py-4 text-start'>
                        <PageStaticData pageData={sp} />
                    </Container>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                    <Container className='py-4 text-start'>
                        <PageStaticData pageData={sp} />
                    </Container>
                    { sp.pageSection ? sp.pageSection.map((sps, index)=>(
                        <Section key={index} sp={sp} ssId={sps.sps_ss_id} sdId={sp.sp_sd_id} />
                    )) : null}
                    </React.Fragment>
                )}
                </React.Fragment>
            ) : (
                <React.Fragment>
                {sp.sp_section_position === 2 ? (
                    <React.Fragment>
                    {sp.pageSection ? sp.pageSection.map((sps, index)=>(
                        <Section key={index} sp={sp} ssId={sps.sps_ss_id} sdId={sp.sp_sd_id} />
                    )) : null}
                    {sp.sp_detail && <Container className='py-4 text-start'>
                        <div dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? sp.sp_detail_hi || sp.sp_detail : sp.sp_detail}} />
                    </Container> }
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                    {sp.sp_detail && <Container className='py-4 text-start'>
                        <div dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? sp.sp_detail_hi || sp.sp_detail : sp.sp_detail}} />
                    </Container> }
                    { sp.pageSection ? sp.pageSection.map((sps, index)=>(
                        <Section key={index} sp={sp} ssId={sps.sps_ss_id} sdId={sp.sp_sd_id} />
                    )) : null}
                    </React.Fragment>
                )}
                </React.Fragment>
            )}
            </React.Fragment>
        }
        </React.Fragment>
    );
}
export default PageBody;